import React from 'react';
import { translate } from '../../utils/wp.js';
import { ModalDialog } from './ModalDialog.js';

export function LockStockDialog({visible, onClick}) {
    return (
        <ModalDialog
            visible={visible}
            primaryActionText={'Ok'}
            primaryAction={onClick}
            secondaryAction={onClick}
            header={translate('locked_stock_title')}
            body={translate('locked_stock_body')}
            hideCloseButton={true}
            isDismissable={true}
        />
    );
}
